import { ApiService } from "Services/ApiService";
import {
  BulkPromotionRequestDTO,
  BulkPromotionResponseDTO,
  BulkPromotionUpdateDTO,
  ResultsDTO
} from "Types";


export const bulkPromotionApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getBulkPromotions: builder.query<ResultsDTO<BulkPromotionResponseDTO[]>, void>({
      query: () => ({
        url: "bulk-promotion",
        method: "GET",
        headers: {
          origin: "origin",
        },
      }),
      providesTags: [{ type: "BulkPromotion", id: "LIST" }],
    }),

    getBulkPromotionById: builder.query<ResultsDTO<BulkPromotionResponseDTO>, number>({
      query: (id) => ({
        url: `bulk-promotion/${id}`,
        method: "GET",
        headers: {
          origin: "origin",
        },
      }),
      providesTags: (result, error, id) => [{ type: "BulkPromotion", id }],
    }),

    createBulkPromotion: builder.mutation<ResultsDTO, BulkPromotionRequestDTO>({
      query: (data) => ({
        url: "bulk-promotion/create",
        method: "POST",
        body: data,
        headers: {
          origin: "origin",
        },
      }),
      invalidatesTags: () => [
        { type: "BulkPromotion", id: "LIST" },
        { type: "AdminProducts", id: "LIST" },
      ],
    }),

    updateBulkPromotion: builder.mutation<ResultsDTO, Partial<BulkPromotionUpdateDTO>>({
      query: (data) => ({
        url: "bulk-promotion/update",
        method: "PUT",
        body: data,
        headers: {
          origin: "origin - origin",
        },
      }),
      invalidatesTags: () => [
        { type: "BulkPromotion", id: "LIST" },
        { type: "AdminProducts", id: "LIST" },
      ],
    }),

    disableBulkPromotion: builder.mutation<ResultsDTO, void>({
      query: () => ({
        url: "bulk-promotion/disable",
        method: "PUT",
        headers: {
          origin: "origin - origin",
        },
      }),
      invalidatesTags: () => [
        { type: "BulkPromotion", id: "LIST" },
        { type: "AdminProducts", id: "LIST" },
      ],
    }),

    deleteBulkPromotion: builder.mutation<ResultsDTO, number>({
      query: (id) => ({
        url: `bulk-promotion/${id}`,
        method: "DELETE",
        headers: {
          origin: "origin",
        },
      }),
      invalidatesTags: () => [
        { type: "BulkPromotion", id: "LIST" },
        { type: "AdminProducts", id: "LIST" },
      ],
    }),

    bulkDeleteBulkPromotions: builder.mutation<ResultsDTO, { ids: number[] }>({
      query: ({ ids }) => ({
        url: "bulk-promotion/bulk-delete",
        method: "DELETE",
        params: { ids },
        headers: {
          origin: "origin",
        },
      }),
      invalidatesTags: () => [{ type: "BulkPromotion", id: "LIST" }],
    }),

    updateBulkPromotionUsage: builder.mutation<ResultsDTO, { hdrId: number; usageCount: number }>({
      query: (data) => ({
        url: "bulk-promotion/usage",
        method: "PUT",
        body: data,
        headers: {
          origin: "origin",
        },
      }),
      // Invalidate so the next cart/checkout load fetches fresh usageUsed counts
      invalidatesTags: [{ type: "BulkPromotion", id: "LIST" }],
    }),
  }),
});

export const {
  useGetBulkPromotionsQuery,
  useGetBulkPromotionByIdQuery,
  useCreateBulkPromotionMutation,
  useUpdateBulkPromotionMutation,
  useDisableBulkPromotionMutation,
  useDeleteBulkPromotionMutation,
  useBulkDeleteBulkPromotionsMutation,
  useUpdateBulkPromotionUsageMutation,
} = bulkPromotionApiSlice;
